<div class="switch" [class.active]="isActive" [class.inactive]="!isActive">
    <span>{{ isActive ? 'ACTIVADO' : 'DESACTIVADO' }}</span>
    <mat-slide-toggle [checked]="isActive" (change)="onToggleChangeWithLog($event)"></mat-slide-toggle>
</div>